import {
  AccountControllerApi,
  AddressControllerApi,
  AllergenControllerApi,
  AuthControllerApi,
  ContactControllerApi,
  DeviceControllerApi,
  DietitianControllerApi,
  DietTypeControllerApi,
  LockedDaysControllerApi,
  MealControllerApi,
  MedicalConditionControllerApi,
  MembershipControllerApi,
  MenuControllerApi,
  OtpControllerApi,
  PartnerApplicationControllerApi,
  PartnerControllerApi,
  PaymentTrackerControllerApi,
  PlanCalendarControllerApi,
  PlanControllerApi,
  PriceOfferControllerApi,
  RegisterControllerApi,
  SelectionControllerApi,
  SubscriptionControllerApi,
  UserControllerApi,
  ZoneControllerApi,
} from "./client";
import i18n from "../i18n";
import { DislikeControllerApi } from "./client/api/dislike-controller-api";
import { getAccessToken, migrateOldSession, refreshAccessToken } from "../utils/tokenStore";
import { apiAxios } from "./apiAxios";

// Set app-language header based on current i18n language
const getAppLanguage = (): "en" | "ar" => {
  const currentLang = i18n.language;
  // Ensure only 'en' or 'ar' are sent
  return currentLang === "ar" ? "ar" : "en";
};

apiAxios.interceptors.request.use(
  (config) => {
    config.headers["app-language"] = getAppLanguage();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Request interceptor — attach in-memory access token to every request
const attachAuthToken = async (config: any) => {
  const token = getAccessToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

apiAxios.interceptors.request.use(attachAuthToken, (error) => Promise.reject(error));

// Fallback 401 response interceptor — handles clock skew and server-side token revocation
const handle401 = async (error: any) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes("/auth/refresh")) {
    originalRequest._retry = true;
    const newToken = (await migrateOldSession()) || (await refreshAccessToken());
    if (newToken) {
      originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
      return apiAxios(originalRequest);
    }
  }
  return Promise.reject(error);
};

apiAxios.interceptors.response.use((response) => response, handle401);

export default {
  Register: new RegisterControllerApi(undefined, undefined, apiAxios),
  Otp: new OtpControllerApi(undefined, undefined, apiAxios),
  Allergen: new AllergenControllerApi(undefined, undefined, apiAxios),
  User: new UserControllerApi(undefined, undefined, apiAxios),
  Meal: new MealControllerApi(undefined, undefined, apiAxios),
  Auth: new AuthControllerApi(undefined, undefined, apiAxios),
  Plan: new PlanControllerApi(undefined, undefined, apiAxios),
  Partner: new PartnerControllerApi(undefined, undefined, apiAxios),
  Menu: new MenuControllerApi(undefined, undefined, apiAxios),
  Payment: new PaymentTrackerControllerApi(undefined, undefined, apiAxios),
  Calendar: new PlanCalendarControllerApi(undefined, undefined, apiAxios),
  Zone: new ZoneControllerApi(undefined, undefined, apiAxios),
  Contact: new ContactControllerApi(undefined, undefined, apiAxios),
  Selection: new SelectionControllerApi(undefined, undefined, apiAxios),
  Subscription: new SubscriptionControllerApi(undefined, undefined, apiAxios),
  Address: new AddressControllerApi(undefined, undefined, apiAxios),
  Dietitian: new DietitianControllerApi(undefined, undefined, apiAxios),
  LockedDays: new LockedDaysControllerApi(undefined, undefined, apiAxios),
  Application: new PartnerApplicationControllerApi(undefined, undefined, apiAxios),
  PriceOffer: new PriceOfferControllerApi(undefined, undefined, apiAxios),
  MedicalConditions: new MedicalConditionControllerApi(undefined, undefined, apiAxios),
  Membership: new MembershipControllerApi(undefined, undefined, apiAxios),
  Account: new AccountControllerApi(undefined, undefined, apiAxios),
  DietType: new DietTypeControllerApi(undefined, undefined, apiAxios),
  Dislike: new DislikeControllerApi(undefined, undefined, apiAxios),
  Device: new DeviceControllerApi(undefined, undefined, apiAxios),
};
